import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c34ed7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-bar"
}

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FakeHeaderBar',
  setup(__props) {

const showFakeHeaderBar = computed(() => {
  return process.env.VUE_APP_SHOW_FAKE_HEADER === 'true'
})

return (_ctx: any,_cache: any) => {
  return (showFakeHeaderBar.value)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})